import { format } from "date-fns";

/* eslint-disable no-restricted-properties */
const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

const checkIsoString = (dat: string) => {
  if (dat.length === 24) {
    return true;
  }
  return false;
};

const formatDate = (date: Date | string | null) =>
  format(new Date(date || ""), "iii', ' MMM ' ' dd', ' yyyy");

const formatHour = (date: Date | string | null) =>
  format(new Date(date || ""), "HH:mm");

const fixHour = (hour: string) => {
  const split = hour.split(":");
  if (split.length === 3) {
    return `${split[0]}:${split[1]} ${
      split[0] && parseInt(split[0], 10) < 12 ? "AM" : "PM"
    }`;
  }
  return hour;
};

function formatTime(timeString: string) {
  const [hourString, minute] = timeString.split(":");
  const hour = +hourString % 24;
  return (hour % 12 || 12) + ":" + minute + " " + (hour < 12 ? "AM" : "PM");
}

const timeToDate = (time: string): Date => {
  const [hour, minute] = time.split(":");
  const date = new Date(0, 0, 0, parseInt(hour, 10), parseInt(minute, 10));
  return date;
};

const twelveTo24Hrs = (time: string): string | null => {
  const matches = time.toLowerCase().match(/(\d{1,2}):(\d{2}) ([ap]m)/);
  if (matches) {
    let hours: string | number =
      matches[1] === "12" && matches[3] == "pm" ? "00" : matches[1];
    if (hours !== "00") {
      hours = parseInt(matches[1]) + (matches[3] === "pm" ? 12 : 0);
    }
    const output = hours + ":" + matches[2];
    return output;
  }
  return null;
};

const FormattedDate = (date: string) => {
  const selectedDate = new Date(date);
  const formattedDate =
    selectedDate.getFullYear() +
    "-" +
    (selectedDate.getMonth() + 1) +
    "-" +
    selectedDate.getDate();
  return formattedDate;
};

const FormattedDateInverse = (date: string) => {
  const selectedDate = new Date(date);
  const formattedDate =
    selectedDate.getDate() +
    "-" +
    (selectedDate.getMonth() + 1) +
    "-" +
    selectedDate.getFullYear();
  return formattedDate;
};

const combineDateAndTime = (dateStr: string, time: string) => {
  const date = new Date(dateStr);
  const timeStr = twelveTo24Hrs(time);
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // Jan is 0, dec is 11
  const day = date.getDate();
  const dateString = "" + year + "-" + month + "-" + day;
  const combined = new Date(dateString + " " + timeStr);

  return combined;
};

const dateToTime = (dateStr: string) => {
  const date = new Date(dateStr);
  const hrs = date.getHours();
  const mins = ("0" + date.getMinutes()).slice(-2);
  return `${hrs}:${mins}`;
};

const DTOSchedule = (schedules: any) => {
  const result = schedules.map((schedule: any) => {
    const { id, time, scene, description, cast, location } = schedule;
    return {
      id,
      time: time && time.length !== 8 ? time : time.substring(0, 5),
      scene,
      description,
      cast,
      location,
    };
  });
  return result;
};

const blobToBase64 = (blob: Blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });

const makeUriMap = (address: string) => {
  const uriMap = `http://maps.google.com/?q=${address.replace(" ", "+")}`;
  return uriMap;
};

export {
  formatBytes,
  formatDate,
  formatHour,
  fixHour,
  dateToTime,
  timeToDate,
  twelveTo24Hrs,
  FormattedDate,
  FormattedDateInverse,
  combineDateAndTime,
  blobToBase64,
  makeUriMap,
  checkIsoString,
  DTOSchedule,
  formatTime,
};
